import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { ExtraConfigKey } from '@/common/sharedDefinitions/commonPlotDefinitions'

const state = {
  editModeReportViewer: false,
  allowEditReportViewer:false,
  currentReportViewer:{},
  forceUpdateReportViewer:0,
  reportListVisReportViewer:true,
  dictIdReportsReportViewer:{},
  dictReportsByUIdReportViewer:{},
  forceUpdReprtsTableReportViewer:false,
  messageVisibleReportViewer:false,
  messageTextReportViewer:'',
  reportModifiedReportViewer:false,
  saveLayoutReportViewer:false,
  visibleStateReportViewer:false,
  reportConfigModifiedReportViewer:false,
  reportStatesListReportViewer:[],
  updatedValueTemplatesReportViewer:{},
  originalConfigurationReportViewer:{},
  loadingGraphsReportViewer:false,
  mappingSetReportViewer: false,
  scanFilesListReportViewer:[],
  visibleExportPDFReportViewer:false,
  toolSideBarVisibleReportViewer:false,
  autoSaveReportViewer:false,
  forceReadFromDBReportViewer:false,
  shortIdCurrentReportViewer:'',
  exportingReportViewer:false,
  studiesReportViewer:[],
  notationReportViewer:'',
  unitsReportViewer:'',
  cachedReportsReportViewer:{},
  reportURLReportViewer:'',
  projectURLReportViewer:'',
  clusterURLReportViewer:'',
}

const getters = {
  isEditModeReportViewer: state => state.editModeReportViewer,
  getCurrentIdReportViewer: state => {
    if(typeof(state.currentReportViewer.id)==='undefined'){
      return ''
    }
    return state.currentReportViewer.id
  },
  getForceUpdateReportViewer:state=>state.forceUpdateReportViewer,
  getCurrentReportViewer:state=>state.currentReportViewer,
  isReportListVisReportViewer:state=>state.reportListVisReportViewer,
  getDictIdReportsReportViewer:state=>state.dictIdReportsReportViewer,
  getDictReportsByUIdReportViewer:state=>state.dictReportsByUIdReportViewer,
  isForceUpdReprtsTableReportViewer:state=>state.forceUpdReprtsTableReportViewer,
  isMessageVisibleReportViewer:state=>state.messageVisibleReportViewer,
  getMessageTextReportViewer:state=>state.messageTextReportViewer,
  isReportModifiedReportViewer:state=>state.reportModifiedReportViewer,
  isReportConfigModifiedReportViewer:state=>state.reportConfigModifiedReportViewer,
  isSaveLayoutReportViewer:state=>state.saveLayoutReportViewer,
  isVisibleStateReportViewer:state=>state.visibleStateReportViewer,
  getReportStatesListReportViewer:state=>state.reportStatesListReportViewer,
  getUpdatedValueTemplatesReportViewer:state=>state.updatedValueTemplatesReportViewer,
  getOriginalConfigurationReportViewer:state=>state.originalConfigurationReportViewer,
  isLoadingGraphsReportViewer:state=>state.loadingGraphsReportViewer,
  isMappingSetReportViewer:state=>state.mappingSetReportViewer,
  getScanFilesListReportViewer:state=>state.scanFilesListReportViewer,
  isVisibleExportPDFReportViewer: state=>state.visibleExportPDFReportViewer,
  isToolSideBarVisibleReportViewer:state=>state.toolSideBarVisibleReportViewer,
  isAllowEditReportViewer:state=>state.allowEditReportViewer,
  isAutoSaveReportViewer: state=>state.autoSaveReportViewer,
  isForceReadFromDBReportViewer: state=>state.forceReadFromDBReportViewer,
  getShortIdCurrentReportViewer: state=>state.shortIdCurrentReportViewer,
  isExportingReportViewer: state=>state.exportingReportViewer,
  getStudiesReportViewer: state=>state.studiesReportViewer,
  getNotationReportViewer: state=>state.notationReportViewer,
  getUnitsReportViewer: state=>state.unitsReportViewer,
  getcachedReportsReportViewer:state=>state.cachedReportsReportViewer,
  getReportURLReportViewer:state=>state.reportURLReportViewer,
  getProjectURLReportViewer:state=>state.projectURLReportViewer,
  getClusterURLReportViewer:state=>state.clusterURLReportViewer,
}

const actions = {
  setDragModeReportViewer ({ commit }, newBool) {
    commit('SET_DRAG_MODE_FLAG_ReportViewer', newBool)
  },
  setCurrentReportViewer ({ commit }, newReport) {
    commit('SET_CURRENT_ReportViewer', newReport)
    if(newReport === null || typeof(newReport[ExtraConfigKey])==='undefined'){
      return
    }
    if(typeof(newReport[ExtraConfigKey][ConfigName.fitLabel])==='undefined') {
      newReport[ExtraConfigKey][ConfigName.fitLabel] = 'mM'
    }
    if(typeof(newReport[ExtraConfigKey][ConfigName.notationFit])==='undefined') {
      newReport[ExtraConfigKey][ConfigName.notationFit] = 'Concentration'
    }
    commit('SET_CACHED_REPORT_ReportViewer', {})
    commit('SET_NOTATION_ReportViewer',newReport[ExtraConfigKey][ConfigName.notationFit])
    commit('SET_UNITS_ReportViewer',newReport[ExtraConfigKey][ConfigName.fitLabel])
  },
  setForceUpdateReportViewer ({ commit }, newInt) { //Regresh the grid of the ReportBoard.vue
    commit('SET_FORCE_UPDATE_ReportViewer', newInt)
  },
  setReportListVisReportViewer({ commit }, newBool) {
    commit('SET_REPORT_LIST_VISIBLE_ReportViewer', newBool)
  },
  setDictIdReportsReportViewer({ commit }, newObject) {
    commit('SET_DICT_ID_REPORTS_ReportViewer', newObject)
  },
  setDictReportsByUIdReportViewer({ commit }, newObject) {
    commit('SET_DICT_NAME_REPORTS_BY_ID_ReportViewer', newObject)
  },
  toggleReportListVisReportViewer({ commit,state }) {
    commit('SET_REPORT_LIST_VISIBLE_ReportViewer', !state.reportListVisReportViewer)
  },
  setForceUpdReprtsTableReportViewer({ commit }, newBool) {
    commit('SET_FORCE_UPD_REPORTS_ReportViewer', newBool)
  },
  setMessageVisibleReportViewer({ commit }, newBool) {
    commit('SET_MESSAGE_VISIBLE_ReportViewer', newBool)
  },
  setMessageTextReportViewer({ commit }, newString) {
    commit('SET_MESSAGE_TEXT_ReportViewer', newString)
  },
  setReportModifiedReportViewer({ commit }) {
    commit('SET_MODIFIED_ReportViewer', true)
  },
  setConfigReportModifiedReportViewer({ commit }) {
    commit('SET_ALL_CONFIG_MODIFIED_ReportViewer')
  },
  resetConfigReportModifiedReportViewer({ commit }) {
    commit('SET_CONFIG_MODIFIED_ReportViewer', false)
  },
  resetReportModifiedReportViewer({ commit }) {
    commit('SET_MODIFIED_ReportViewer', false)
    commit('SET_CONFIG_MODIFIED_ReportViewer', false)
  },
  setSaveLayoutReportViewer({ commit }, newBool) {
    commit('SET_SAVE_LAYOUT_ReportViewer', newBool)
  },
  setReportStatesListReportViewer({ commit }, newList) {
    commit('SET_STATES_LIST_ReportViewer', newList)
    const newBool = newList.length>1
    commit('SET_STATES_VISIBILITY_ReportViewer', newBool)
  },
  setUpdatedValueTemplatesReportViewer({ commit }, newObject) {
    commit('SET_UPDATED_VAL_TEMPLATE_ReportViewer', newObject)
  },
  setOriginalConfigurationReportViewer({ commit }, newObject) {
    commit('SET_ORIGINAL_CONFIGURATION_ReportViewer', newObject)
  },
  setLoadingGraphsReportViewer({ commit }, newBool) {
    commit('SET_LOADING_GRAPHS_ReportViewer', newBool)
  },
  setMappingSetReportViewer({ commit }, newBool) {
    commit('SET_MAPPING_FLAG_ReportViewer', newBool)
  },
  setScanFilesListReportViewer({ commit }, newArray) {
    commit('SET_SCAN_FILES_ReportViewer', newArray)
  },
  setVisibleExportPDFReportViewer({ commit }, newBool) {
    commit('SET_VISIBLE_EXPORT_PDF_ReportViewer', newBool)
  },
  setToolSideBarVisibleReportViewer({ commit }, newBool) {
    commit('SET_VISIBLE_TOOL_SIDEBAR_ReportViewer', newBool)
  },
  setAllowEditReportViewer({ commit }, newBool) {
    if(!newBool){
      //Set edit mode to false
      commit('SET_DRAG_MODE_FLAG_ReportViewer', false)
    }
    commit('SET_ALLOW_EDIT_ReportViewer', newBool)
  },
  setAutoSaveReportViewer({ commit }, newBool) {
    commit('SET_AUTOSAVE_ReportViewer', newBool)
  },
  setForceReadFromDBReportViewer({ commit }, newBool) {
    commit('SET_FORCE_READ_DB_ReportViewer', newBool)
  },
  setShortIdCurrentReportViewer({ commit }, newStr) {
    commit('SET_SHORT_ID_ReportViewer', newStr)
  },
  setExportingReportViewer({ commit }, newBool) {
    commit('SET_EXPORTING_ReportViewer', newBool)
  },
  setStudiesReportViewer({ commit }, newArr) {
    commit('SET_STUDIES_ReportViewer', newArr)
  },
  addStudiesReportViewer({ commit }, newVal) {
    commit('ADD_STUDIES_ReportViewer', newVal)
  },
  delStudiesReportViewer({ commit }, removeElement) {
    commit('DEL_STUDIES_ReportViewer', removeElement)
  },
  setNotationReportViewer({ commit }, newString) {
    commit('SET_NOTATION_ReportViewer', newString)
  },
  setUnitsReportViewer({ commit }, newString) {
    commit('SET_UNITS_ReportViewer', newString)
  },
  cleanCacheReportViewer({ commit }) {
    commit('SET_CACHED_REPORT_ReportViewer', {})
  },
  async retrieveReportObjtReportViewer({state, commit, dispatch}, {reportId, projectId, clusterId, nameStr}){
    if(typeof(state.cachedReportsReportViewer[reportId]) !== 'undefined')
      return state.cachedReportsReportViewer[reportId];
    commit('SET_MESSAGE_TEXT_ReportViewer', `Loading ${nameStr}...`)
    //Get the report from the back-end
    const reportObject = await dispatch('readSingleReportMiddleware',{
      projectId: projectId,
      reportId: reportId,
      clusterId: clusterId,
    });
    if(reportObject !== null && typeof(reportObject) !== 'undefined')
      state.cachedReportsReportViewer[reportId] = reportObject
    return reportObject
  },
  setReportURLReportViewer({ commit }, newString) {
    commit('SET_REPORT_URL_ReportViewer', newString)
  },
  setProjectURLReportViewer({ commit }, newString) {
    commit('SET_PROJECT_URL_ReportViewer', newString)
  },
  setClusterURLReportViewer({ commit }, newString) {
    commit('SET_CLUSTER_URL_ReportViewer', newString)
  },
}

const mutations = {
  SET_DRAG_MODE_FLAG_ReportViewer: (state, boolVal) => (state.editModeReportViewer = boolVal),
  SET_CURRENT_ReportViewer: (state, newReport) => (state.currentReportViewer = newReport),
  SET_FORCE_UPDATE_ReportViewer: (state, newInt) => (state.forceUpdateReportViewer = newInt),
  SET_REPORT_LIST_VISIBLE_ReportViewer: (state, boolVal) => (state.reportListVisReportViewer = boolVal),
  SET_DICT_ID_REPORTS_ReportViewer: (state, newObject) => (state.dictIdReportsReportViewer = newObject),
  SET_DICT_NAME_REPORTS_BY_ID_ReportViewer: (state, newObject) => (state.dictReportsByUIdReportViewer = newObject),
  SET_FORCE_UPD_REPORTS_ReportViewer: (state, boolVal) => (state.forceUpdReprtsTableReportViewer = boolVal),
  SET_MESSAGE_VISIBLE_ReportViewer: (state, boolVal) => (state.messageVisibleReportViewer = boolVal),
  SET_MESSAGE_TEXT_ReportViewer: (state, newString) => (state.messageTextReportViewer = newString),
  SET_MODIFIED_ReportViewer: (state, boolVal) => (state.reportModifiedReportViewer = boolVal),
  SET_CONFIG_MODIFIED_ReportViewer: (state, boolVal) => (state.reportConfigModifiedReportViewer = boolVal),
  SET_SAVE_LAYOUT_ReportViewer: (state, boolVal) => (state.saveLayoutReportViewer = boolVal),
  SET_STATES_LIST_ReportViewer: (state, newList) => (state.reportStatesListReportViewer = newList),
  SET_STATES_VISIBILITY_ReportViewer: (state, boolVal) => (state.visibleStateReportViewer = boolVal),
  SET_UPDATED_VAL_TEMPLATE_ReportViewer: (state, object) => (state.updatedValueTemplatesReportViewer = object),
  SET_ORIGINAL_CONFIGURATION_ReportViewer: (state, object) => (state.originalConfigurationReportViewer = object),
  SET_ALL_CONFIG_MODIFIED_ReportViewer: (state) => {
    state.reportModifiedReportViewer = true
    state.reportConfigModifiedReportViewer = true
  },
  SET_LOADING_GRAPHS_ReportViewer: (state, boolVal) => (state.loadingGraphsReportViewer = boolVal),
  SET_MAPPING_FLAG_ReportViewer: (state, boolVal) => (state.mappingSetReportViewer = boolVal),
  SET_SCAN_FILES_ReportViewer: (state, newArray) => (state.scanFilesListReportViewer = newArray),
  SET_VISIBLE_EXPORT_PDF_ReportViewer: (state, boolVal) => (state.visibleExportPDFReportViewer = boolVal),
  SET_VISIBLE_TOOL_SIDEBAR_ReportViewer: (state, boolVal) => (state.toolSideBarVisibleReportViewer = boolVal),
  SET_ALLOW_EDIT_ReportViewer: (state, boolVal) => (state.allowEditReportViewer = boolVal),
  SET_AUTOSAVE_ReportViewer: (state, boolVal) => (state.autoSaveReportViewer = boolVal),
  SET_FORCE_READ_DB_ReportViewer: (state, boolVal) => (state.forceReadFromDBReportViewer = boolVal),
  SET_EXPORTING_ReportViewer: (state, boolVal) => (state.exportingReportViewer = boolVal),
  SET_SHORT_ID_ReportViewer: (state, strVal) => (state.shortIdCurrentReportViewer = strVal),
  SET_STUDIES_ReportViewer: (state, newArr) => (state.studiesReportViewer = newArr),
  ADD_STUDIES_ReportViewer: (state, newVal) => (state.studiesReportViewer.push(newVal)),
  SET_NOTATION_ReportViewer:(state, stringVal) => (state.notationReportViewer = stringVal),
  SET_UNITS_ReportViewer:(state, stringVal) => (state.unitsReportViewer = stringVal),
  DEL_STUDIES_ReportViewer: (state, removeElement) => {
    if(typeof(state.currentReportViewer.configuration[removeElement.configKey])!=='undefined')
      delete state.currentReportViewer.configuration[removeElement.configKey];
    state.studiesReportViewer.splice(removeElement.index, 1)
  },
  SET_CACHED_REPORT_ReportViewer: (state, object) => (state.cachedReportsReportViewer = object),
  SET_REPORT_URL_ReportViewer:(state, stringVal) => (state.reportURLReportViewer = stringVal),
  SET_PROJECT_URL_ReportViewer:(state, stringVal) => (state.projectURLReportViewer = stringVal),
  SET_CLUSTER_URL_ReportViewer:(state, stringVal) => (state.clusterURLReportViewer = stringVal),
}

export default {
  state,
  getters,
  actions,
  mutations
}
